/**
 * Dinheiro em centavos. Nenhum ponto do sistema faz aritmética em float com
 * reais — a conversão para exibição acontece somente na borda de apresentação.
 */
export const BRL = 'BRL';
/** 123456 => "R$ 1.234,56" */
export function formatCents(cents, options) {
    if (cents === null || cents === undefined || Number.isNaN(cents))
        return options?.blank ?? '—';
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: BRL });
}
/** 123456 => "1.234,56" (sem símbolo, para colunas numéricas de tabela) */
export function formatCentsPlain(cents) {
    if (cents === null || cents === undefined || Number.isNaN(cents))
        return '—';
    return (cents / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
/**
 * Converte o que o operador digitou ("1.234,56", "1234.56", "R$ 10") em centavos.
 * Devolve null quando o texto não representa um número.
 */
export function parseCents(input) {
    if (input === null || input === undefined || input === '')
        return null;
    if (typeof input === 'number')
        return Math.round(input * 100);
    const cleaned = input.replace(/[^\d,.-]/g, '').trim();
    if (cleaned === '' || cleaned === '-')
        return null;
    // pt-BR usa vírgula como separador decimal; o ponto é separador de milhar.
    const hasComma = cleaned.includes(',');
    const normalized = hasComma ? cleaned.replace(/\./g, '').replace(',', '.') : cleaned;
    const value = Number(normalized);
    if (Number.isNaN(value))
        return null;
    return Math.round(value * 100);
}
/** Soma segura de centavos (evita `undefined` propagando NaN). */
export function sumCents(values) {
    return values.reduce((acc, v) => acc + (v ?? 0), 0);
}
//# sourceMappingURL=money.js.map